import { render, staticRenderFns } from "./Scores.vue?vue&type=template&id=36193a4c&"
import script from "./Scores.vue?vue&type=script&lang=ts&"
export * from "./Scores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports